import type { Epic } from 'Flux/index.js'
import { projectSlice } from 'Flux/Slice/Project/ProjectSlice.js'
import { catchError, filter, mergeMap, of, withLatestFrom } from 'rxjs'

export const DeleteParticipantEpic: Epic = (action$, state$, { [projectSlice.name]: project, ProjectRepository }) =>
  action$.pipe(
    filter(project.removeParticipantRequest.match),
    withLatestFrom(state$),
    mergeMap(([action]) => {
      return ProjectRepository.removeParticipant(action.payload.projectId, action.payload.participantId).pipe(
        mergeMap(() => of(project.removeParticipantRequestSuccess(action.payload))),
        catchError((error) => of(project.getParticipantsRequestFailure({ error })))
      )
    })
  )
